import { Category, OptionGroup } from '../../../../../types';
import { toOptions } from './toOptions';

export const toOptionGroups = (data: Category[]): OptionGroup<string>[] =>
  data.map((category) => ({
    label: category.title,
    meta: category.meta,
    options: toOptions(category.childCategories ?? []),
  }));
